export default "__VITE_ASSET__0b13a177__"